import { Plus } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Pagination } from '@/components/common/Pagination';
import { SearchBar } from '@/components/common/SearchBar';
import { Button } from '@/components/ui/button';
import { userConfigStore } from '@/stores';
import { CreateDefinitionDialog } from './components/CreateDefinitionDialog';
import { DefinitionTable } from './components/DefinitionTable';
import { UserAssignmentDrawer } from './components/UserAssignmentDrawer';

export const UserConfigPage = observer(() => {
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  useEffect(() => {
    userConfigStore.fetchDefinitions();
  }, []);

  useEffect(() => {
    userConfigStore.fetchDefinitions();
  }, [
    userConfigStore.definitionsPagination.page,
    userConfigStore.definitionsPagination.pageSize,
  ]);

  const handleSearch = (keyword: string) => {
    userConfigStore.setDefinitionsKeyword(keyword);
    userConfigStore.fetchDefinitions();
  };

  return (
    <div className="bg-white rounded-lg border border-border shadow-sm">
      <div className="p-6 space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-lg font-semibold text-foreground">
              用户配置管理
            </h1>
            <p className="text-sm text-muted-foreground mt-0.5">
              定义配置项并将其分配给特定用户，前端可按需查询
            </p>
          </div>
          <Button onClick={() => setCreateDialogOpen(true)}>
            <Plus className="mr-2 h-4 w-4" />
            创建配置
          </Button>
        </div>

        <SearchBar
          placeholder="搜索配置键或描述..."
          onSearch={handleSearch}
          className="max-w-md"
        />

        <div className="space-y-4">
          <DefinitionTable />
          <Pagination
            page={userConfigStore.definitionsPagination.page}
            pageSize={userConfigStore.definitionsPagination.pageSize}
            total={userConfigStore.definitionsPagination.total}
            onPageChange={(page) =>
              userConfigStore.setDefinitionsPagination(page)
            }
          />
        </div>
      </div>

      <CreateDefinitionDialog
        open={createDialogOpen}
        onOpenChange={setCreateDialogOpen}
      />

      <UserAssignmentDrawer />
    </div>
  );
});
